import React, { FC } from 'react';
import { Loading } from 'components/atoms/loading';
import { AddCustomDomain } from './add-custom-domain';
import { Space } from './custom-domain.styles';
import { DefaultDomain } from './default-domain';
import { DomainRecords } from './domain-records';
import { CustomDomainLayout } from './layout';
import { useCustomDomainActions } from './use-custom-domain-actions';
import { Verified } from './verified';
import { VerifyDomain } from './verify-domain';

export const CustomDomain: FC = () => {
  const {
    customDomainConfig,
    defaultDomainName,
    primaryDomainName,
    verificationStatus,
    isLoading,
    isFetching,
    isVerifying,
    isValidationError,
    isVerified,
    isAdding,
    onAdd,
    onVerify,
    refetchData,
  } = useCustomDomainActions();

  return (
    <CustomDomainLayout>
      {isLoading ? (
        <Loading />
      ) : (
        <Space size={32}>
          <DefaultDomain url={defaultDomainName} />
          <AddCustomDomain
            onAdd={onAdd}
            domain={
              customDomainConfig ? customDomainConfig.domainName : undefined
            }
            loading={isAdding}
          />

          {/* Steps */}
          {!isVerified ? (
            <>
              <DomainRecords
                data={customDomainConfig ? customDomainConfig.cnames : []}
                refetch={refetchData}
                isFetching={isFetching}
              />
              <VerifyDomain
                onVerify={onVerify}
                loading={isVerifying}
                verificationStatus={verificationStatus}
                isError={isValidationError}
              />
            </>
          ) : null}

          {/* Verification */}
          {isVerified ? <Verified url={primaryDomainName} /> : null}
        </Space>
      )}
    </CustomDomainLayout>
  );
};
